import React, { useMemo } from "react";
import RosterBlock from "./RosterBlock";
import { useJSONFetcher } from "@outplayed/json-fetcher";
import { API_WOW_ROOT_PATH } from "api/apiHelpers";

const EchoOtherPlayers = ({ personalData, currentPlayer, wclData, showTitle = false, numPlayers = 3 }) => {
  const { data: armoryData, loading: armoryDataIsLoading } = useJSONFetcher(`${API_WOW_ROOT_PATH}/probuilds/roster.json`, {
    ssr: true,
  });

  const randomThreePlayers = useMemo(() => {
    return personalData?.filter((player) => player.name !== currentPlayer).slice(0, numPlayers);
    // The below shuffles the players in order to return three random, but it causes bugs where the data
    // used in each block becomes a mixture of different players' data
    // const dataSansCurrentPlayer = personalData.filter((player) => player.name !== currentPlayer);
    // return [...dataSansCurrentPlayer].sort(() => 0.5 - Math.random()).slice(0, 1);
  }, [currentPlayer]);

  if (armoryDataIsLoading) return null;

  return (
    <div className="other-players-container">
      {showTitle && <div className="other-players-title">Other Team Echo Players</div>}
      <div className="roster-blocks-container">
        {randomThreePlayers?.map((player, index) => (
          <RosterBlock personalData={player} armoryData={armoryData} wclData={wclData} key={index} />
        ))}
      </div>
    </div>
  );
};

export default EchoOtherPlayers;
